import { PTextList, PTextListItem } from "@porsche-design-system/components-react"
import { FormattedMessage } from "react-intl"
import type { MessageDescriptor } from "react-intl"

export const DisablementReasonList = ({
	disablementLabel,
	disablementReasons,
}: {
	disablementLabel: MessageDescriptor
	disablementReasons: MessageDescriptor[]
}) => {
	if (disablementReasons.length === 0) {
		return null
	}

	return (
		<>
			<FormattedMessage {...disablementLabel} />
			<PTextList>
				{disablementReasons.map((reason, index) => (
					<PTextListItem key={index}>
						<FormattedMessage {...reason} />
					</PTextListItem>
				))}
			</PTextList>
		</>
	)
}
